const SprintBurndownChart = (data = []) => {
  const colors = {
    completed: '#36B37E', // green
    ideal: '#4C9AFF',     // blue
    remaining: '#FF5630'  // red
  };

  return {
    tooltip: {
      trigger: 'axis',
      formatter: function(params) {
        const day = params[0].axisValue;
        const header = `<b>${day}</b><br/>`;
        const details = params.map(p => `${p.marker} ${p.seriesName}: ${p.value}`).join('<br/>');
        return header + details;
      }
    },
    legend: {
      show: false
    },
    grid: {
      left: 0,
      right: 0,
      bottom: 35,
      top: 20,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: data.map(d => d.date),
      axisLabel: { rotate: 0 }
    },
    yAxis: {
      type: 'value',
      name: 'Story Points',
      min: 0,
      max: 45
    },
    series: [
      {
        name: 'Completed',
        type: 'bar',
        data: data.map(d => d.completed),
        itemStyle: {
          color: colors.completed,
          borderRadius: [4, 4, 0, 0]
        }
      },
      {
        name: 'Ideal',
        type: 'line',
        smooth: true,
        data: data.map(d => d.ideal),
        lineStyle: {
          color: colors.ideal,
          width: 3
        },
        areaStyle: {
          opacity: 0.15,
          color: {
            type: 'linear',
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: colors.ideal },
              { offset: 1, color: 'transparent' }
            ]
          }
        }
      },
      {
        name: 'Remaining',
        type: 'line',
        smooth: true,
        data: data.map(d => d.remaining),
        lineStyle: {
          color: colors.remaining,
          width: 3
        },
        areaStyle: {
          opacity: 0.15,
          color: {
            type: 'linear',
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: colors.remaining },
              { offset: 1, color: 'transparent' }
            ]
          }
        }
      }
    ]
  };
};

export default SprintBurndownChart;
